import AbstractElement from "../../pages/AbstractElement";
import TabNav from "./TabNav";
import 'slick-carousel';
import 'owl.carousel';
import TabContent from "./TabContent";

class SectionTab extends AbstractElement {

    private activeID: number;
    private tabNav: TabNav;
    private tabContent: TabContent;

    constructor(template: JQuery) {
        super(template);
    }

    init(): void {
        this.activeID = 0;
        this.initTabNav();
        this.initTabContent();
    }

    private initTabNav(): void {
        this.tabNav = new TabNav(this.template.find('> .tab__nav'));
        this.tabNav.emitter.on('TAB_NAV_CLICK', (data) => {
            this.activeID = data.id;
            this.tabContent.changeItem(this.activeID);
            this.changeBgColor(data.bgColor);
        });
    }

    private initTabContent(): void {
        this.tabContent = new TabContent(this.template.find('> .tab__content'));
    }

    public changeContentHeight(): void {
        this.tabContent.resizeContentHeight();
    }
    public changeBgColor(color: string): void {
        this.tabContent.changeBgColor(color);
    }


}

export default SectionTab;